import { competitionResponse } from './../responses/responses';
import gql from 'graphql-tag';
import { memberResponse, teamResponse } from '../responses/responses';

export const publicCompetitionsQuery = `
  query($entityId:String!, $seasonId: String) {
  publicCompetitions(entityId: $entityId seasonId: $seasonId)
    {
      id
      entityId
      typeId
      seasonId
      name
      externalLink
      categoryId
      sportId
      icon
      favourite
      individual
    }
  }
`;

export const teamsParticipatingCompetitionQuery =
  `
  query($entityId:String!, $competitionId: String!) {
  teamsParticipatingCompetition(entityId: $entityId, competitionId: $competitionId)
    {
      ` +
  teamResponse +
  `
    }
  }
`;

export const extraCompetitionQuery = `
  query($entityId:String!, $competitionId: String!) {
  publicExtraCompetition(entityId: $entityId, competitionId: $competitionId) {
    id
    entityId
    typeId
    seasonId
    name
    externalLink
    individual
    categoryId
    sportId
    icon
    favourite
    private
    showClassification
    numberTeamsUp
    numberTeamsDown
    showPlayOff
    playOff
    omegaball
    groups{
      id
      name
      participantsId
      isPlayOff
      playOffRound
    }
    withoutMatch{
      objectId
      competitionGroupId
      playOffRound
      playOffMatch
    }
    multimedia{
      id
      name
      public
      active
      anyone
      items {
        id
        url
        userId
        isVideo
      }
    }
    classification{
      objectId
      name
      position
      points
      pj
      pg
      pe
      pp
      gf
      gc
      dg
      coefficient
      victoryPercentage
    }
    matchDays {
        id
        detail
        startDate
        finishDate
        competitionGroupId
        isConsolation
        pairings {
          id
          localId
          visitorId
          thirdId
        }
      }
      matches {
        id
        localId
        visitorId
        thirdId
        statusId
        typeId
        date
        localResult
        visitorResult
        thirdResult
        matchDayId
        pairingId
        competitionGroupId
        playOffRound
        playOffMatch
        equipments {
          localShirt
          localShorts
          localSocks
          visitorShirt
          visitorShorts
          visitorSocks
          thirdShirt
          thirdShorts
          thirdSocks
        }
        location{
          id
          entityId
          name
          capacity
          geolocation{
            latitude
            longitude
            formattedAddress
          }
        }
        
      }
    }
  }
`;

export const membersParticipatingCompetitionQuery =
  `
  query($entityId:String!, $competitionId: String!) {
  membersParticipatingCompetition(entityId: $entityId, competitionId: $competitionId)
    {
      ` +
  memberResponse +
  `
    }
  }
`;

export const externalTeamsParticipatingCompetitionQuery = `
  query($entityId:String!, $competitionId: String!) {
  externalTeamsParticipatingCompetition(entityId: $entityId, competitionId: $competitionId)
    {
      id
      name
      image
      team {
        id
        entityId
        name
        categoryId
        sportId
        shield
        favourite
      }
    }
  }
`;

export const generatePairingsQuery = `
  query($entityId:String!, $competitionId: String!, $mode: String!, $pairing: String!) {
  generatePairings(entityId: $entityId, competitionId: $competitionId, mode: $mode, pairing: $pairing)
    {
      id
      detail
      startDate
      finishDate
      pairings {
        id
        localId
        visitorId
        thirdId
        externalReference
      }
    }
  }
`;

export const generateExternalPairingsQuery = `
  query($entityId:String!, $competitionId: String!) {
  generateExternalPairings(entityId: $entityId, competitionId: $competitionId)
    {
      id
      detail
      startDate
      finishDate
      pairings {
        id
        localId
        visitorId
        thirdId
        externalReference
      }
    }
  }
`;
